<script setup>
import { computed, getCurrentInstance, ref } from 'vue';
import Checkbox from '@legacy/components/common/form/checkbox/Checkbox.vue';
import GenericModal from '../common/modal/GenericModal.vue';
import KgrButton from '../common/form/button/KgrButton.vue';

const { headline, message, showBookingHint, showDialog } = defineProps({
    headline: {
        type: String,
        required: false,
        default: null,
    },
    message: {
        type: String,
        required: false,
        default: null,
    },
    showBookingHint: {
        type: Boolean,
        required: false,
        default: false,
    },
    showDialog: {
        type: Boolean,
        required: true,
    },
});

const emit = defineEmits(['cancel', 'confirm']);
const { proxy } = getCurrentInstance();
const notifyParticipants = ref(true);
const notifyClubEmployees = ref(true);

const tHeadline = computed(() => {
    return headline || proxy.$t('confirmInformal');
});

const handleConfirm = () => {
    emit('confirm', {
        notifyParticipants: notifyParticipants.value,
        notifyClubEmployees: notifyClubEmployees.value,
    });
};

const handleCancel = () => {
    emit('cancel');
};
</script>

<template>
    <generic-modal
        v-if="showDialog"
        :value="showDialog"
        :headline="tHeadline"
        @post-input="handleCancel"
    >
        <div
            v-if="message"
            class="kgr-readingBlock"
        >
            {{ message }}
        </div>
        <div
            v-if="showBookingHint"
            class="kgr-readingBlock kgr-text kgr-text--italic mt1"
        >
            {{ $t('Eine Buchung, die bereits abgerechnet ist, wird nicht automatisch entfernt. Hierfür wird gegebenenfalls ein Eintrag unter &quot;Angebotsbuchungen&quot; im Hinweissystem erzeugt.') }}
        </div>
        <div class="kgr-readingBlock mt1">
            {{ $t('Welche Personen, die in diesem Angebot eingebucht sind, sollen über die Änderung benachrichtigt werden?') }}
        </div>
        <div class="notification-checkboxes mt1">
            <checkbox
                :checked="notifyParticipants"
                :label="$t('Teilnehmer benachrichtigen')"
                click-area-minimized
                @change="value => (notifyParticipants = value)"
            />
            <checkbox
                :checked="notifyClubEmployees"
                :label="$t('Trainer benachrichtigen')"
                click-area-minimized
                @change="value => (notifyClubEmployees = value)"
            />
        </div>
        <template #footer>
            <kgr-button
                type="grey"
                :value="$t('Abbrechen')"
                @click="handleCancel"
            />
            <kgr-button
                :value="$t('Ok')"
                @click="handleConfirm"
            />
        </template>
    </generic-modal>
</template>

<style scoped lang="scss">
.notification-checkboxes {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}
</style>
